import { Shapes } from '@components/shapes';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { Color } from '@styles/theme';

import type { ApplicationStatus } from 'types/applications';

export type ApplicationMetaVariant = ApplicationStatus | 'neutral';

export type ApplicationMetaRowProps = {
  variant: ApplicationMetaVariant;
  label: string;
  detail?: string;
};

const variantColors: { [variant in ApplicationMetaVariant]: Color } = {
  neutral: 'elementPurple100',
  active: 'elementBlue100',
  hired: 'elementGreen200',
  rejected: 'elementRed100',
  retracted: 'elementOrange100',
};

export function ApplicationMetaRow(props: ApplicationMetaRowProps) {
  const { variant, label, detail } = props;
  const color = variantColors[variant];

  return (
    <Stack orientation="horizontal" space={2} align="center" wrap>
      <Shapes.Circle size={8} color={color} />
      <Text text={label} font="semibold12" color={color} />
      {detail && <Text text={`• ${detail}`} font="regular12" color="textHelper" />}
    </Stack>
  );
}
